import { InformationCircleBold } from '@ha/icons';
import React from 'react';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Card, CardContent, Grid, units } from '@hbf/dsl';

interface Props {
  isSquare?: boolean;
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    background: theme.palette.secondary.light,
    border: units.border(1, 'solid', theme.palette.secondary.main),
    color: theme.palette.grey[700],
  },
  icon: {
    fontSize: units.rem(1),
    verticalAlign: 'bottom',
  },
}));

const PromotionalBooking: React.FC<Props> = ({ isSquare = false }) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <Card className={classes.container} elevation={0} square={isSquare}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item>
            <InformationCircleBold
              className={classes.icon}
              color="secondary"
              data-test-locator="Promotional Booking Info Icon"
            />
          </Grid>
          <Grid item xs={10} data-test-locator="Promotional Booking Info Text">
            {T(
              'For all bookings with a move-in date between 15.04.20 and 30.06.20, no booking fee applies.',
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export { PromotionalBooking };
